import React from 'react';
import { TCN } from './tokens';

/**
 * TCN FAB — Floating Action Button (mobile pattern, iOS-flavored).
 *
 * Floats bottom-right above the TabBar. Uses the cyan brand color (the only
 * spot in the app where cyan still drives a CTA, since the mockup primary
 * button moved to white-cream).
 *
 * Props:
 *  - onClick
 *  - icon: React node (e.g. <Icon name="plus" size={22} />)
 *  - aria-label: accessibility label
 *  - showTabs: boolean (default true) — adjusts bottom offset to clear the TabBar
 *  - color: 'cyan' | 'magenta' (default 'cyan')
 */
const FAB = ({
  onClick,
  icon,
  ariaLabel = 'Action',
  showTabs = true,
  color = 'cyan',
  style,
}) => {
  const bg = color === 'magenta' ? TCN.magenta : TCN.cyan;
  // TabBar height ≈ 80 + safe-area; sit 16px above its top edge.
  const bottom = showTabs
    ? 'calc(96px + env(safe-area-inset-bottom, 0px))'
    : 'calc(16px + env(safe-area-inset-bottom, 0px))';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      style={{
        position: 'fixed',
        insetInlineEnd: 16,
        bottom,
        width: 56,
        height: 56,
        borderRadius: 28,
        background: bg,
        color: '#000',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `0 8px 24px ${bg}55, 0 2px 6px rgba(0,0,0,0.4)`,
        zIndex: 30,
        transition: 'transform 120ms ease',
        ...style,
      }}
      onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.94)'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
    >
      {icon}
    </button>
  );
};

export default FAB;
